import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

const NetworkStatus: React.FC = () => {
  const isOnline = useNetworkStatus();
  const [showOffline, setShowOffline] = React.useState(false);

  React.useEffect(() => {
    if (!isOnline) {
      setShowOffline(true);
    } else {
      setShowOffline(false);
    }
  }, [isOnline]);

  return (
    <Snackbar
      open={showOffline}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: 10000 }}
    >
      <Alert 
        severity="warning" 
        sx={{ width: '100%' }}
        role="alert"
        aria-live="assertive"
      >
        You're currently offline. Some features may not work properly.
      </Alert>
    </Snackbar>
  );
};

export default NetworkStatus;